import { createContext, useContext } from "react";

/** Horizontal padding, in spacing units, from a chat's edges. */
export type ChatGutter = {
  /** The composer, the disclaimer, and the chrome around the chat: the title row and the chat list. */
  composer: number;
  /** The conversation and the new-chat suggestions, usually inset past the composer so it reads a little wider than the chat. */
  conversation: number;
};

/**
 * Null keeps each part's own padding. A host whose chat already sits inside
 * an outer gap sets it so the two add up to the gaps it wants.
 */
const ChatGutterContext = createContext<ChatGutter | null>(null);
ChatGutterContext.displayName = "ChatGutterContext";

export const ChatGutterProvider = ChatGutterContext.Provider;

export const useChatGutter = () => useContext(ChatGutterContext);

/**
 * For a scroll container inside a chat with a gutter set. A classic scrollbar
 * takes its width from the right side only, so the gutters would no longer match.
 */
export const HIDDEN_SCROLLBAR_SX = {
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": { display: "none" },
} as const;
